<template>
  <div class="users-style">
    <h4 class="mb-2 pb-2 border-bottom mt-3">Attendance Import</h4>

    <p style="font-size: 15px;">
      Upload attendance Excel file for processing.
    </p>

    <b-card class="bg-wash box-shadow-none border-0 mt-3">
      <b-overlay :show="loading" rounded="sm">
        <b-form @submit.prevent="uploadFile">
          <b-form-group
            label="Attendance File"
            label-for="attendance_file"
            class="required-field"
          >
            <b-form-file
              id="attendance_file"
              v-model="file"
              accept=".xlsx,.xls,.csv"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              browse-text="Browse"
            ></b-form-file>

            <small class="text-muted">
              Allowed file types: .xlsx, .xls, .csv
            </small>
          </b-form-group>

          <div v-if="file" class="alert alert-info py-2">
            Selected file: <strong>{{ file.name }}</strong>
          </div>

          <div v-if="errors.length > 0" class="alert alert-danger">
            <strong>Total errors: {{ errors.length }}</strong>
            <ul class="mb-0 mt-2">
              <li v-for="(error, index) in errors" :key="index">
                {{ error }}
              </li>
            </ul>
          </div>

          <div v-if="successMessage" class="alert alert-success">
            {{ successMessage }}
          </div>

          <b-button type="submit" variant="primary" :disabled="!file || loading">
            Upload
          </b-button>

          <b-button type="button" class="ml-2" variant="secondary" @click="resetForm">
            Reset
          </b-button>
        </b-form>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      file: null,
      loading: false,
      errors: [],
      successMessage: ''
    };
  },

  methods: {
    uploadFile() {
      if (!this.file) {
        this.errors = ['Please select a file.'];
        return;
      }

      this.loading = true;
      this.errors = [];
      this.successMessage = '';

      let formData = new FormData();
      formData.append('attendance_file', this.file);

      axios.post(this.$api_url + '/la/attendance/upload/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((response) => {
        this.successMessage = response.data.message || 'File uploaded successfully.';

        if (response.data.errors && response.data.errors.length > 0) {
          this.errors = response.data.errors;
        }

        this.file = null;
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          if (error.response.data.errors) {
            this.errors = Object.values(error.response.data.errors).flat();
          } else if (error.response.data.message) {
            this.errors = [error.response.data.message];
          } else {
            this.errors = ['Upload failed.'];
          }
        } else {
          this.errors = ['Upload failed. Please try again.'];
        }
      })
      .finally(() => {
        this.loading = false;
      });
    },

    resetForm() {
      this.file = null;
      this.errors = [];
      this.successMessage = '';
    }
  }
};
</script>